/**
 * @module lib/data
 * library functions for transforming data
 */

import Immutable from "immutable";

export class KeyValueListLengthMismatchError extends Error {
  
  // TODO: this is duck-typing, because babel is broken
  static type = "KeyValueListLengthMismatchError";
  
  constructor(keyList, valueList) {
    super( `Length mismatch on keyList(${keyList.length})/valueList(${valueList.length})`);
    this.keyList = keyList;
    this.valueList = valueList;
    this.type = KeyValueListLengthMismatchError.type;
  }
  
}

 /**
  * mapArrayToEntity - Convert an array to an object by mapping indexes to keys
  *
  * @param  {Array} keyList   maps indeces from valueArray to property names on the returned object e.g. ["id", "name"]
  * @param  {Array} valueList list of values to be mapped ["2632", "Test"]
  * @returns {Object}         entity object
  */
export function mapArrayToEntity(keyList, valueList) {
  if ( keyList.length !== valueList.length ) {
    throw new KeyValueListLengthMismatchError(keyList, valueList);
  }
  // Loop through the key/value lists and map each value in the target object
  let targetEntity = {};
  for (let i = 0; i < keyList.length; i = i + 1) {
    const keyName = keyList[i];
    const value   = valueList[i];
    targetEntity[keyName] = value;
  }

  return targetEntity;
}

/**
 * Convert a List to an OrderedMap using the given keyMapper function.
 * @param {Function} keyMapper maps a value to its key
 * @param {Immutable~List} list
 * @returns {Immutable~OrderedMap}
 */
export function listToMap(keyMapper, list) {
  return list.reduce((map, listItem, index) => {
    const key = keyMapper(listItem, index);
    return map.set(key, listItem);
  }, new Immutable.OrderedMap());
}

/**
 * Create a Map from an Array using the gievn entityMapper and keyMapper
 * @param {Function} entityMapper maps list items to entities
 * @param {Function} keyMapper maps a value to its key
 * @param {Array} list
 * @returns {Immutable~OrderedMap}
 */
export function arrayToEntityMap(entityMapper, keyMapper, list) {
  return listToMap(keyMapper, list.map(entityMapper));
}

/**
 * pruneImmutable - Delete a key from an immutable collection, and then delete
 *   all of that key's empty ancestors
 *
 * @param {Immutable.Collection} immutable - the immutable object to delete from
 * @param {Array<string>} keyPath - Immutable keyPath of the target key (used for deleteIn)
 * @param {number} [minDepth] - optional, index in keyPath at which to stop traversing
 * @returns {Immutable.Collection} a new immutable collection of the same type
 */
export function pruneImmutable(immutable, keyPath, minDepth) {
  // copy keyPath so we can pop without side effects
  keyPath = keyPath.slice(0);
  // do..while since we always want to delete the leaf on the first iteration
  do {
    immutable = immutable.deleteIn(keyPath);
    // move to the parent
    keyPath.pop();
  // if the parent is empty then continue deleting
  // exit condition when we reach minDepth
  } while (immutable.getIn(keyPath).isEmpty() && keyPath.length > minDepth)
  return immutable;
}



// WEBPACK FOOTER //
// ./src/lib/data/index.js